import type { AvatarItem } from "src/reducks/AvatarStore/types";
import type { FetchAvatarParts } from "src/service/AvatarApi/types";

// 初期アバター

export const defaultHairstyle: AvatarItem = {
  id: "HR001",
  bought: true,
  category: "HAIR",
  image:
    "https://hataraku-bu-main-bucket.s3.ap-northeast-1.amazonaws.com/avatar/thumbnail/%E9%AB%AA_1_Fix.png",
  magnification: 2,
  name: "髪１",
  parts: [
    {
      id: "HA001_1",
      avatarItemId: "HR001",
      category: "HAIR",
      image:
        "https://hataraku-bu-main-bucket.s3.ap-northeast-1.amazonaws.com/avatar/item/87_%E9%AB%AA%E5%9E%8B1%E6%89%8B%E5%89%8D.png",
      layer: 87,
    },
    {
      id: "HR001_2",
      avatarItemId: "HR001",
      category: "HAIR",
      image:
        "https://hataraku-bu-main-bucket.s3.ap-northeast-1.amazonaws.com/avatar/item/15_%E9%AB%AA%E5%9E%8B1%E5%A5%A5.png",
      layer: 15,
    },
  ],
  point: 555,
};
export const defaultStageHairstyle: FetchAvatarParts[] = [
  {
    id: "HA001_1",
    avatarItemId: "HR001",
    category: "HAIR",
    image:
      "https://hataraku-bu-main-bucket.s3.ap-northeast-1.amazonaws.com/avatar/item/87_%E9%AB%AA%E5%9E%8B1%E6%89%8B%E5%89%8D.png",
    layer: 87,
  },
  {
    id: "HR001_2",
    avatarItemId: "HR001",
    category: "HAIR",
    image:
      "https://hataraku-bu-main-bucket.s3.ap-northeast-1.amazonaws.com/avatar/item/15_%E9%AB%AA%E5%9E%8B1%E5%A5%A5.png",
    layer: 15,
  },
];
export const defaultBody: AvatarItem = {
  id: "BD001",
  bought: true,
  category: "BODY",
  image:
    "https://hataraku-bu-main-bucket.s3.ap-northeast-1.amazonaws.com/avatar/thumbnail/%E7%B4%A0%E4%BD%93.png",
  magnification: 2,
  name: "素体",
  parts: [
    {
      id: "BD001_1",
      avatarItemId: "BD001",
      category: "BODY",
      image:
        "https://hataraku-bu-main-bucket.s3.ap-northeast-1.amazonaws.com/avatar/item/30_%E7%B4%A0%E4%BD%93.png",
      layer: 30,
    },
    {
      id: "BD001_2",
      avatarItemId: "BD001",
      category: "BODY",
      image:
        "https://hataraku-bu-main-bucket.s3.ap-northeast-1.amazonaws.com/avatar/item/35_%E7%B4%A0%E4%BD%93%E8%80%B3%E6%89%8B%E5%89%8D.png",
      layer: 35,
    },
  ],
  point: 555,
};
export const defaultStageBody: FetchAvatarParts[] = [
  {
    id: "BD001_1",
    avatarItemId: "BD001",
    category: "BODY",
    image:
      "https://hataraku-bu-main-bucket.s3.ap-northeast-1.amazonaws.com/avatar/item/30_%E7%B4%A0%E4%BD%93.png",
    layer: 30,
  },
  {
    id: "BD001_2",
    avatarItemId: "BD001",
    category: "BODY",
    image:
      "https://hataraku-bu-main-bucket.s3.ap-northeast-1.amazonaws.com/avatar/item/35_%E7%B4%A0%E4%BD%93%E8%80%B3%E6%89%8B%E5%89%8D.png",
    layer: 35,
  },
];

export const defaultFace: AvatarItem = {
  id: "FA001",
  bought: true,
  category: "FACE",
  image:
    "https://hataraku-bu-main-bucket.s3.ap-northeast-1.amazonaws.com/avatar/thumbnail/%E9%A1%94_1A.png",
  magnification: 2,
  name: "顔1Ａ",
  parts: [
    {
      id: "FA001_1",
      avatarItemId: "FA001",
      category: "FACE",
      image:
        "https://hataraku-bu-main-bucket.s3.ap-northeast-1.amazonaws.com/avatar/item/85_%E9%A1%941A.png",
      layer: 85,
    },
  ],
  point: 555,
};
export const defaultStageFace: FetchAvatarParts[] = [
  {
    id: "FA001_1",
    avatarItemId: "FA001",
    category: "FACE",
    image:
      "https://hataraku-bu-main-bucket.s3.ap-northeast-1.amazonaws.com/avatar/item/85_%E9%A1%941A.png",
    layer: 85,
  },
];
export const defaultTops: AvatarItem = {
  id: "TP001",
  bought: true,
  category: "TOPS",
  image:
    "https://hataraku-bu-main-bucket.s3.ap-northeast-1.amazonaws.com/avatar/thumbnail/%E3%83%96%E3%83%AC%E3%82%B6%E3%83%BC_%E3%83%88%E3%83%83%E3%83%97%E3%82%B9_%E5%88%B6%E6%9C%8D_Fix.png",
  magnification: 2,
  name: "学生服 ブレザー(男女兼)",
  parts: [
    {
      id: "TP001_1",
      avatarItemId: "TP001",
      category: "TOPS",
      image:
        "https://hataraku-bu-main-bucket.s3.ap-northeast-1.amazonaws.com/avatar/item/50_%E3%83%96%E3%83%AC%E3%82%B6%E3%83%BC%E4%B8%8A.png",
      layer: 50,
    },
    {
      id: "TP001_2",
      avatarItemId: "TP001",
      category: "TOPS",
      image:
        "https://hataraku-bu-main-bucket.s3.ap-northeast-1.amazonaws.com/avatar/item/53_%E3%83%96%E3%83%AC%E3%82%B6%E3%83%BC%E6%89%8B%E5%89%8D%E3%81%AE%E8%85%95.png",
      layer: 53,
    },
    {
      id: "TP001_3",
      avatarItemId: "TP001",
      category: "TOPS",
      image:
        "https://hataraku-bu-main-bucket.s3.ap-northeast-1.amazonaws.com/avatar/item/46_%E3%83%96%E3%83%AC%E3%82%B6%E3%83%BC%E4%B8%8A%E5%A5%A5%E3%81%AE%E8%85%95.png",
      layer: 46,
    },
  ],
  point: 555,
};
export const defaultStageTops: FetchAvatarParts[] = [
  {
    id: "TP001_1",
    avatarItemId: "TP001",
    category: "TOPS",
    image:
      "https://hataraku-bu-main-bucket.s3.ap-northeast-1.amazonaws.com/avatar/item/50_%E3%83%96%E3%83%AC%E3%82%B6%E3%83%BC%E4%B8%8A.png",
    layer: 50,
  },
  {
    id: "TP001_2",
    avatarItemId: "TP001",
    category: "TOPS",
    image:
      "https://hataraku-bu-main-bucket.s3.ap-northeast-1.amazonaws.com/avatar/item/53_%E3%83%96%E3%83%AC%E3%82%B6%E3%83%BC%E6%89%8B%E5%89%8D%E3%81%AE%E8%85%95.png",
    layer: 53,
  },
  {
    id: "TP001_3",
    avatarItemId: "TP001",
    category: "TOPS",
    image:
      "https://hataraku-bu-main-bucket.s3.ap-northeast-1.amazonaws.com/avatar/item/46_%E3%83%96%E3%83%AC%E3%82%B6%E3%83%BC%E4%B8%8A%E5%A5%A5%E3%81%AE%E8%85%95.png",
    layer: 46,
  },
];
export const defaultBottoms: AvatarItem = {
  id: "BT001",
  bought: true,
  category: "BOTTOMS",
  image:
    "https://hataraku-bu-main-bucket.s3.ap-northeast-1.amazonaws.com/avatar/thumbnail/ブレザー_ボトムス_スラックス_Fix.png",
  magnification: 2,
  name: "学生服 スラックス",
  parts: [
    {
      id: "BT001_1",
      avatarItemId: "BT001",
      category: "BOTTOMS",
      image:
        "https://hataraku-bu-main-bucket.s3.ap-northeast-1.amazonaws.com/avatar/item/40_%E3%83%96%E3%83%AC%E3%82%B6%E3%83%BC%E4%B8%8B%E7%94%B7.png",
      layer: 40,
    },
  ],
  point: 555,
};
export const defaultStageBottoms: FetchAvatarParts[] = [
  {
    id: "BT001_1",
    avatarItemId: "BT001",
    category: "BOTTOMS",
    image:
      "https://hataraku-bu-main-bucket.s3.ap-northeast-1.amazonaws.com/avatar/item/40_%E3%83%96%E3%83%AC%E3%82%B6%E3%83%BC%E4%B8%8B%E7%94%B7.png",
    layer: 40,
  },
];
export const defaultShoes: AvatarItem = {
  id: "SH002",
  bought: true,
  category: "SHOES",
  image:
    "https://hataraku-bu-main-bucket.s3.ap-northeast-1.amazonaws.com/avatar/thumbnail/%E3%83%96%E3%83%AC%E3%82%B6%E3%83%BC_%E9%9D%B4_%E3%83%AD%E3%83%BC%E3%83%95%E3%82%A1%E3%83%BC_Fix.png",
  magnification: 3,
  name: "ローファー(男女兼)",
  parts: [
    {
      id: "SH002_1",
      avatarItemId: "SH002",
      category: "SHOES",
      image:
        "https://hataraku-bu-main-bucket.s3.ap-northeast-1.amazonaws.com/avatar/item/38_%E3%83%AD%E3%83%BC%E3%83%95%E3%82%A1%E3%83%BC%E5%89%8D.png",
      layer: 38,
    },
  ],
  point: 555,
};
export const defaultStageShoes: FetchAvatarParts[] = [
  {
    id: "SH002_1",
    avatarItemId: "SH002",
    category: "SHOES",
    image:
      "https://hataraku-bu-main-bucket.s3.ap-northeast-1.amazonaws.com/avatar/item/38_%E3%83%AD%E3%83%BC%E3%83%95%E3%82%A1%E3%83%BC%E5%89%8D.png",
    layer: 38,
  },
];
